var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuasBertanam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Luas_Bertanam",
    "data-name": "Luas Bertanam",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M884.572,1189.976a2.571,2.571,0,1,1,2.571-2.572A2.575,2.575,0,0,1,884.572,1189.976Zm0-4.286a1.714,1.714,0,1,0,1.714,1.714A1.716,1.716,0,0,0,884.572,1185.69Z",
    transform: "translate(-863.142 -1165.976)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M866.572,1189.976a2.571,2.571,0,1,1,2.572-2.572A2.575,2.575,0,0,1,866.572,1189.976Zm0-4.286a1.714,1.714,0,1,0,1.714,1.714A1.716,1.716,0,0,0,866.572,1185.69Z",
    transform: "translate(-864 -1165.976)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M875.572,1189.976a2.571,2.571,0,1,1,2.572-2.572A2.575,2.575,0,0,1,875.572,1189.976Zm0-4.286a1.714,1.714,0,1,0,1.714,1.714A1.716,1.716,0,0,0,875.572,1185.69Z",
    transform: "translate(-873 -1184.833)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M552.429,307.429A.429.429,0,0,1,552,307V292.429a.429.429,0,0,1,.857,0V307A.429.429,0,0,1,552.429,307.429Z",
    transform: "translate(-549.429 -287.714)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M569,311.857H554.429a.429.429,0,1,1,0-.857H569a.429.429,0,0,1,0,.857Z",
    transform: "translate(-549.714 -290.428)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M826,1325.857h-2.571a.429.429,0,1,1,0-.857H826a.429.429,0,0,1,0,.857Z",
    transform: "translate(-820.429 -1318.143)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M826,1325.857h-2.571a.429.429,0,1,1,0-.857H826a.429.429,0,0,1,0,.857Z",
    transform: "translate(-820.429 -1307.857)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M3,.857H.429A.429.429,0,0,1,.429,0H3A.429.429,0,0,1,3,.857Z",
    transform: "translate(6.857 18) rotate(90)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M3,.857H.429A.429.429,0,0,1,.429,0H3A.429.429,0,0,1,3,.857Z",
    transform: "translate(12 18) rotate(90)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M3,.857H.429A.429.429,0,0,1,.429,0H3A.429.429,0,0,1,3,.857Z",
    transform: "translate(17.143 18) rotate(90)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M826,1325.857h-2.571a.429.429,0,1,1,0-.857H826a.429.429,0,0,1,0,.857Z",
    transform: "translate(-820.429 -1313)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(9 3.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M922.276,195.571a.255.255,0,0,1-.21-.11A6.273,6.273,0,0,1,921,193.276a1.276,1.276,0,0,1,2.551,0,6.275,6.275,0,0,1-1.066,2.186A.255.255,0,0,1,922.276,195.571Zm0-3.061a.766.766,0,0,0-.765.765.975.975,0,1,0,1.531,0A.766.766,0,0,0,922.276,192.51Z",
    transform: "translate(-916.918 -192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M917.276,199.551a1.276,1.276,0,0,1,0-2.551,6.286,6.286,0,0,1,2.186,1.065.255.255,0,0,1,0,.42A6.285,6.285,0,0,1,917.276,199.551Zm0-2.041a.765.765,0,0,0,0,1.531,4.955,4.955,0,0,0,1.58-.765A4.955,4.955,0,0,0,917.276,197.51Z",
    transform: "translate(-914.469 -194.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M922.276,203.578A1.277,1.277,0,0,1,921,202.3a6.273,6.273,0,0,1,1.066-2.186.264.264,0,0,1,.419,0,6.275,6.275,0,0,1,1.066,2.186A1.277,1.277,0,0,1,922.276,203.578Zm0-2.855a4.96,4.96,0,0,0-.765,1.58.765.765,0,0,0,1.531,0A4.961,4.961,0,0,0,922.276,200.723Z",
    transform: "translate(-916.918 -195.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M926.3,199.551a6.285,6.285,0,0,1-2.186-1.065.255.255,0,0,1,0-.42A6.285,6.285,0,0,1,926.3,197a1.276,1.276,0,0,1,0,2.551Zm-1.58-1.275a4.955,4.955,0,0,0,1.58.765.765.765,0,1,0,0-1.531A4.955,4.955,0,0,0,924.716,198.276Z",
    transform: "translate(-918.388 -194.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M923.255,210.612a.255.255,0,0,1-.245-.325c1.023-3.583,2.084-5.287,5.347-5.287a.255.255,0,0,1,.212.4c-.532.8-.925,1.528-1.271,2.172C926.313,209.4,925.661,210.612,923.255,210.612Zm4.624-5.088c-2.489.156-3.4,1.587-4.281,4.568,1.819-.1,2.343-1.078,3.251-2.766C927.141,206.784,927.466,206.181,927.879,205.525Z",
    transform: "translate(-917.898 -198.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M918.357,210.612c-2.406,0-3.057-1.211-4.043-3.044-.346-.644-.739-1.374-1.271-2.172a.255.255,0,0,1,.212-.4c3.263,0,4.324,1.7,5.347,5.287a.255.255,0,0,1-.245.325Zm-4.623-5.088c.413.657.738,1.26,1.03,1.8.908,1.688,1.432,2.661,3.251,2.766C917.131,207.111,916.222,205.681,913.734,205.525Z",
    transform: "translate(-913 -198.367)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuasBertanam);
export default __webpack_public_path__ + "static/media/luasBertanam.112585fd2191dcf5a539ee86ccd544a1.svg";
export { ForwardRef as ReactComponent };